import React from "react";
import Link from "gatsby-link";

export default ({ links }) => {
  return (
    <div className="c-header--nav">
      {links.map((link, idx) => (
        <div key={idx} className="c-header--nav--item a--underline">
          <Link to={link.to}>{link.text}</Link>
        </div>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/molecules/Navbar.js